import api from './index';
import type { EmailAction } from '@/types/emailTypes';

export default {
  async getPDF(expendeduria_id: number | null) {
    try {
      const response = await api.get(`/expendedurias/${expendeduria_id}/pdf/`, {
        responseType: 'blob', // Importante para manejar binarios
        timeout: 15000
      });

      const blob = new Blob([response.data], { type: 'application/pdf' });
      const pdfUrl = window.URL.createObjectURL(blob);

      // Crear enlace temporal
      const link = document.createElement('a');
      link.href = pdfUrl;
      link.target = '_blank';
      link.rel = 'noopener noreferrer'; // Importante para seguridad
      link.download = `reporte-${expendeduria_id}.pdf`;

      // Simular clic
      document.body.appendChild(link);
      link.click();

      // Limpieza
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(pdfUrl);
      }, 100);
    } catch (error) {
      console.error('Error generando el PDF:', error);
      // 3. Mostrar feedback al usuario
      throw new Error('No se pudo generar el PDF. Verifique la conexión o los parámetros');
    }
  },
  async sendEmail(expendeduria_id: number | null, emailType: EmailAction) {
    if (!expendeduria_id) {
      console.error('ID de expendeduría inválido');
      return;
    }

    try {
      // Llamada al backend
      const response = await api.post(`/expendedurias/${expendeduria_id}/enviar-correo/`, {
        expendeduria_id, // Si quieres que el backend use el ID
        emailType // Tipo de correo a enviar
      }, {
        timeout: 15000
      });
    } catch (error) {
      console.error('Error enviando el correo:', error);
      throw new Error('No se pudo enviar el correo. Verifique la conexión.');
    }
  },
  async sendEmailCredenciales(expendeduria_id: number | null) {
    if (!expendeduria_id) {
      console.error('ID de expendeduría inválido');
      return;
    }

    try {
      // Llamada al backend
      const response = await api.post(`/expendedurias/${expendeduria_id}/enviar-correo-credenciales/`, {
        expendeduria_id, // Si quieres que el backend use el ID
      }, {
        timeout: 15000
      });

      alert('Correo enviado correctamente');
    } catch (error) {
      console.error('Error enviando el correo:', error);
      alert('No se pudo enviar el correo. Verifique la conexión.');
    }
  },
  async sendEmailSepa(expendeduria_id: number | null) {
    if (!expendeduria_id) {
      console.error('ID de expendeduría inválido');
      return;
    }

    try {
      // Llamada al backend
      const response = await api.post(`/expendedurias/${expendeduria_id}/enviar-correo-sepa/`, {
        expendeduria_id, // Si quieres que el backend use el ID
      }, {
        timeout: 15000
      });

      alert('Correo enviado correctamente');
    } catch (error) {
      console.error('Error enviando el correo:', error);
      alert('No se pudo enviar el correo. Verifique la conexión.');
    }
  },
};